(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lib-about-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-liba-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-liba-toggle]');
      const menu = nav.querySelector('[data-liba-menu]');
      if (!toggle || !menu) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        menu.classList.toggle('is-open', !open);
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-brands-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-libbr-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-libbr-toggle]');
      const menu = nav.querySelector('[data-libbr-menu]');
      if (!toggle || !menu) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('is-open', !open); });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-business-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-libbu-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-libbu-toggle]'); const menu = nav.querySelector('[data-libbu-menu]'); if (!toggle || !menu) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('is-open', !open); });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close)); document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-contact-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-libco-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-libco-toggle]'); const menu = nav.querySelector('[data-libco-menu]'); if (!toggle || !menu) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('is-open', !open); });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close)); document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-menu-toggle]');
      const menu = nav.querySelector('[data-menu]');
      if (!toggle || !menu) return;
      const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
      };
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        menu.classList.toggle('is-open', !expanded);
      });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-kinsei-life-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-libk-nav]').forEach((nav) => {
      const toggle = nav.querySelector('[data-libk-toggle]'); const menu = nav.querySelector('[data-libk-menu]'); if (!toggle || !menu) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); menu.classList.remove('is-open'); };
      toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') === 'true'; toggle.setAttribute('aria-expanded', String(!open)); menu.classList.toggle('is-open', !open); });
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', close)); document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lib-luchar-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-lucharp-nav]').forEach(n=>{const b=n.querySelector('[data-lucharp-toggle]'),m=n.querySelector('[data-lucharp-menu]');if(!b||!m)return;b.addEventListener('click',()=>{const o=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!o));m.classList.toggle('open',!o)})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
